import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { summaryDataByMasterIdAtom } from '../../components/tree/summaries/atoms'
import { useMemo } from 'react'
import { treeSummaryMappings } from '../../components/tree/summaries/utility'
import {
  useEditableTreeForPrimaryTreeId,
  useRetrieveEditableForPrimary,
} from '../../api/tree.hooks'
import { currentSelectedMasterAtom } from './atoms'

export function useMappingDataForMaster(masterId: string) {
  const editableTree = useEditableTreeForPrimaryTreeId(masterId)
  const summaryData = useAtomValue(summaryDataByMasterIdAtom)
  const treeData = summaryData[masterId]
  return useMemo(() => {
    if (!editableTree?.tree) return
    return treeSummaryMappings(treeData, editableTree.tree)
  }, [editableTree, treeData])
}

export function useCurrentSelectedEditableIds() {
  const masterId = useAtomValue(currentSelectedMasterAtom)
  const retriever = useRetrieveEditableForPrimary()
  if (!masterId) return {}
  return retriever(masterId)
}
